<app-loading *ngIf="loading"></app-loading>
<div class="panel-header panel-header-sm">
    <div class="row link-header ml-5">
        <div>
            <a class="a-home" routerLink="/home">Home/</a>
        </div>
        <div>
            <a class="text-info" routerLink="/company-type">Propietario & Empresa</a>
        </div>
    </div>
</div>

<div class="main-content">

    <!-- INPUT'S -->
    <div class="row">
        <div class="col-md-7">
            <div class="row">                
                <!-- INPUT OWNER -->
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header ">
                            <div class="row">
                                <div class="col-10">
                                    <b class="card-title" *ngIf="!isEdit">Nuevo Propietario</b>
                                    <b class="card-title text-warning" *ngIf="isEdit">Modificar Propietario</b>
                                </div>
                                <div class="col-2 text-right" *ngIf="isEdit">
                                    <a class="btn btn-round btn-danger btn-icon btn-sm remove btn-erp"
                                        (click)="cancelUpdate($event)"><i class="fas fa-times"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-6">
                                    <label>*Nombre</label>
                                    <div class="form-group">
                                        <input type="text" class="form-control" [(ngModel)]="owner.ownerName" />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <label>*Correo</label>
                                    <div class="form-group">
                                        <input type="text" class="form-control" [(ngModel)]="owner.ownerEmail" />
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <label>*Teléfono</label>
                                    <div class="form-group">
                                        <input type="text" class="form-control" [(ngModel)]="owner.ownerPhone" />
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <label>DPI</label>
                                    <div class="form-group">
                                        <input type="text" class="form-control" [(ngModel)]="owner.ownerDocument" />
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <label>*Nit</label>
                                    <div class="form-group">
                                        <input type="text" class="form-control" [(ngModel)]="owner.ownerTaxDocument" />
                                    </div>
                                </div>
                                <div class="col-md-8">
                                    <label>Dirección</label>
                                    <div class="form-group">
                                        <input type="text" class="form-control" [(ngModel)]="owner.ownerAddress" />
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <label>&nbsp;</label>
                                    <button class="btn btn-info btn-block btn-erp" (click)="save()" *ngIf="!isEdit"
                                        [disabled]="isDisabled">Guardar</button>
                                    <button class="btn btn-primary btn-block btn-erp" (click)="update()" *ngIf="isEdit"
                                        [disabled]="isDisabled">Actualizar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- END INPUT OWNER -->

                <!-- TABLE OWNER -->
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <h4 class="card-title">Listado de Propietarios</h4>
                            <h6 class="category">Puedes filtrar por cualquier campo en la caja de texto "Search
                                records"</h6>
                        </div>
                        <div class="card-body">
                            <div class="dataTables_wrapper">
                                <div class="row">
                                    <div class="col-sm-12 col-md-6">
                                        <div class="dataTables_length" id="datatable_length">
                                            <label>
                                                Show
                                                <select name="datatable_length" aria-controls="datatable"
                                                    class="form-control form-control-sm"
                                                    (change)="entriesChange($event)">
                                                    <option value="10" [selected]="entries==10">10</option>
                                                    <option value="25" [selected]="entries==25">25</option>
                                                    <option value="50" [selected]="entries==50">50</option>
                                                    <option value="-1" [selected]="entries==-1">All</option>
                                                </select>
                                                entries
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-sm-12 col-md-6">
                                        <div id="datatable_filter" class="dataTables_filter">
                                            <label>
                                                <input type="search" class="form-control form-control-sm"
                                                    placeholder="Search records" aria-controls="datatable"
                                                    (keyup)="filterTable($event)" />
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <ngx-datatable class="bootstrap selection-cell" [columnMode]="'force'"
                                    [headerHeight]="50" [footerHeight]="50" [rowHeight]="'auto'"
                                    [limit]="entries != -1 ? entries:undefined" [rows]="temp"
                                    (activate)="onActivate($event)">
                                    <ngx-datatable-column name="Nombre"></ngx-datatable-column>
                                    <ngx-datatable-column name="Telefono"></ngx-datatable-column>
                                    <ngx-datatable-column [sortable]="false" [canAutoResize]="false" [draggable]="false"
                                        [resizeable]="false">
                                        <ng-template ngx-datatable-header-template let-value="value"
                                            let-allRowsSelected="allRowsSelected" let-selectFn="selectFn">
                                            Acciones
                                        </ng-template>
                                        <ng-template ngx-datatable-cell-template let-value="value"
                                            let-isSelected="isSelected" let-onCheckboxChangeFn="onCheckboxChangeFn">
                                            <a href="#" class="btn btn-round btn-info btn-icon btn-sm like"
                                                (click)="viewFunction($event)" ngbTooltip="Ver"><i
                                                    class="fas fa-eye"></i>
                                            </a>
                                            <a href="#" class="btn btn-round btn-success btn-icon btn-sm edit"
                                                (click)="editFunction($event)" ngbTooltip="Editar"><i
                                                    class="fas fa-pencil-alt"></i>
                                            </a>
                                            <a href="#" class="btn btn-round btn-danger btn-icon btn-sm remove"
                                                (click)="deleteFunction($event)" ngbTooltip="Eliminar"><i
                                                    class="fas fa-times"></i>
                                            </a>
                                        </ng-template>
                                    </ngx-datatable-column>
                                </ngx-datatable>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- TABLE OWNER -->
            </div>
        </div>

        <div class="col-md-5">
            <div class="row">  
                <!-- INPUT OWNER - COMPANY -->
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header ">
                            <div class="row">
                                <div class="col-sm-8">
                                    <b class="card-title" *ngIf="!isEditCompanyOwner">Crear Relacion Propietario - Empresa</b>
                                    <b class="card-title text-warning" *ngIf="isEditCompanyOwner">Modificar Relacion Propietario
                                        - Empresa</b>
                                </div>
                                <div class="col-sm-4 text-right" *ngIf="isEditCompanyOwner">
                                    <a class="btn btn-round btn-danger btn-icon btn-sm remove btn-erp"
                                        (click)="cancelUpdateCompanyOwner($event)"><i class="fas fa-times"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>Propietario</label>
                                        <angular2-multiselect [data]="ownerListSelect" [(ngModel)]="selectedItemsOwner"
                                            [settings]="dropdownSettings" (onSelect)="onItemSelectOwner($event)">
                                        </angular2-multiselect>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>Empresa</label>
                                        <angular2-multiselect [data]="companyList" [(ngModel)]="selectedItemsCompany"
                                            [settings]="dropdownSettingsCompany" (onSelect)="onItemSelectCompany($event)">
                                        </angular2-multiselect>
                                    </div>
                                </div>
                                <div class="col-sm-12">
                                    <button class="btn btn-info btn-block btn-erp" (click)="saveCompanyOwner()"
                                        *ngIf="!isEditCompanyOwner" [disabled]="isDisabled">Guardar</button>
                                    <button class="btn btn-primary btn-block btn-erp" (click)="updateCompanyOwner()"
                                        *ngIf="isEditCompanyOwner" [disabled]="isDisabled">Actualizar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- END INPUT OWNER COMPANY -->

                <!-- TABLE OWNER COMPANY -->
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <h4 class="card-title">Listado de Propietarios - Empresa</h4>
                            <h6 class="category">Puedes filtrar por cualquier campo en la caja de texto "Search
                                records"</h6>
                        </div>
                        <div class="card-body">
                            <div class="dataTables_wrapper">
                                <div class="row">
                                    <div class="col-sm-12 col-md-6">
                                        <div class="dataTables_length" id="datatable_length">
                                            <label>
                                                Show
                                                <select name="datatable_length" aria-controls="datatable"
                                                    class="form-control form-control-sm" (change)="entriesChange2($event)">
                                                    <option value="10" [selected]="entries2==10">10</option>
                                                    <option value="25" [selected]="entries2==25">25</option>
                                                    <option value="50" [selected]="entries2==50">50</option>
                                                    <option value="-1" [selected]="entries2==-1">All</option>
                                                </select>
                                                entries
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-sm-12 col-md-6">
                                        <div id="datatable_filter" class="dataTables_filter">
                                            <label>
                                                <input type="search" class="form-control form-control-sm"
                                                    placeholder="Search records" aria-controls="datatable"
                                                    (keyup)="filterTable2($event)" />
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <ngx-datatable class="bootstrap selection-cell" [columnMode]="'force'" [headerHeight]="50"
                                    [footerHeight]="50" [rowHeight]="'auto'" [limit]="entries2 != -1 ? entries2:undefined"
                                    [rows]="tempCompanyOwner" (activate)="onActivate($event)">
                                    <ngx-datatable-column name="Empresa"></ngx-datatable-column>
                                    <ngx-datatable-column name="Propietario"></ngx-datatable-column>
                                    <ngx-datatable-column [sortable]="false" [canAutoResize]="false" [draggable]="false"
                                        [resizeable]="false">
                                        <ng-template ngx-datatable-header-template let-value="value"
                                            let-allRowsSelected="allRowsSelected" let-selectFn="selectFn">
                                            Acciones
                                        </ng-template>
                                        <ng-template ngx-datatable-cell-template let-value="value" let-isSelected="isSelected"
                                            let-onCheckboxChangeFn="onCheckboxChangeFn">
                                            <a href="#" class="btn btn-round btn-success btn-icon btn-sm edit"
                                                (click)="editFunctionCompanyOwner($event)" ngbTooltip="Editar"><i
                                                    class="fas fa-pencil-alt"></i>
                                            </a>
                                        </ng-template>
                                    </ngx-datatable-column>
                                </ngx-datatable>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- END TABLE OWNER COMPANY -->
            </div>
        </div>
</div>